import { Toggle } from '../common/Toggle'

interface NotificationToggleProps {
  label: string
  description: string
  contactInfo: string
  enabled: boolean
  onChange: (enabled: boolean) => void
  disabled?: boolean
}

export function NotificationToggle({
  label,
  description,
  contactInfo,
  enabled,
  onChange,
  disabled = false,
}: NotificationToggleProps) {
  const containerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1rem',
    padding: '1rem 0',
    borderBottom: '1px solid #e5e7eb',
  }

  const contentStyles: React.CSSProperties = {
    flex: 1,
  }

  const labelStyles: React.CSSProperties = {
    fontSize: '14px',
    fontWeight: 500,
    color: '#1a1a1a',
    marginBottom: '4px',
  }

  const descriptionStyles: React.CSSProperties = {
    fontSize: '13px',
    color: '#6b7280',
    marginBottom: '4px',
  }

  const contactStyles: React.CSSProperties = {
    fontSize: '12px',
    color: '#9ca3af',
  }

  const toggleWrapperStyles: React.CSSProperties = {
    paddingTop: '2px',
  }

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <div style={labelStyles}>{label}</div>
        <div style={descriptionStyles}>{description}</div>
        <div style={contactStyles}>{contactInfo}</div>
      </div>
      <div style={toggleWrapperStyles}>
        <Toggle checked={enabled} onChange={onChange} disabled={disabled} aria-label={label} />
      </div>
    </div>
  )
}
